export var DeliveryLifecycleDetail;
(function (DeliveryLifecycleDetail) {
    DeliveryLifecycleDetail["USER_STEP_CONDITION"] = "step_condition";
    DeliveryLifecycleDetail["SUBSCRIBER_PREFERENCE"] = "preference";
    DeliveryLifecycleDetail["USER_MISSING_PHONE"] = "missing_phone";
    DeliveryLifecycleDetail["USER_MISSING_EMAIL"] = "missing_email";
    DeliveryLifecycleDetail["USER_MISSING_PUSH_TOKEN"] = "missing_push_token";
    DeliveryLifecycleDetail["USER_MISSING_WEBHOOK_URL"] = "missing_webhook_url";
    DeliveryLifecycleDetail["USER_MISSING_CREDENTIALS"] = "some_channels_missing_credentials";
    DeliveryLifecycleDetail["WORKFLOW_MISSING_CHANNEL_STEP"] = "workflow_missing_channel_step";
    /** Blocked by our own suppression list before the provider was contacted. */
    DeliveryLifecycleDetail["SUPPRESSED_RECIPIENT"] = "suppressed_recipient";
    DeliveryLifecycleDetail["UNKNOWN_ERROR"] = "unknown_error";
    DeliveryLifecycleDetail["EXECUTION_STOPPED"] = "execution_stopped";
    DeliveryLifecycleDetail["EXECUTION_CANCELED_BY_USER"] = "execution_canceled_by_user";
})(DeliveryLifecycleDetail || (DeliveryLifecycleDetail = {}));
//# sourceMappingURL=delivery-lifecycle-detail.enum.js.map